import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  BuildingBaseData,
  BuildingFilterDto,
  BuildingItemDto,
  BuildingService,
  RegionItemDto,
  TeamItemDto,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CurrentUserService } from '@services/current-user.service';
import { NbDialogService } from '@nebular/theme';
import { CustomAction } from '@shared/generic/data-table/data-table.component';
import {
  ProfiNeoSyncDialogComponent,
} from '@components/dialog/profi-neo-sync-dialog/profi-neo-sync-dialog.component';
import TenantTypeEnum = BuildingFilterDto.TenantTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-building-overview-page',
  templateUrl: './building-overview-page.component.html',
  styleUrls: ['./building-overview-page.component.scss'],
})
export class BuildingOverviewPageComponent {

  private readonly router = inject(Router);
  private readonly formBuilder = inject(FormBuilder);
  private readonly buildingService = inject(BuildingService);
  private readonly currentUserService = inject(CurrentUserService);
  private readonly dialogService = inject(NbDialogService);
  protected readonly TenantTypeEnum = TenantTypeEnum;

  canCreateBuildings = computed(() => this.currentUserService.hasPrivilege('canCreateBuildings'));
  form!: FormGroup;

  readonly loadBuildings = (filter: BuildingFilterDto) => this.buildingService.findAll({ ...filter, tenantType: TenantTypeEnum.External });
  readonly getCount = (filter: BuildingFilterDto) => this.buildingService.getCount({ ...filter, tenantType: TenantTypeEnum.External });

  readonly customActions: CustomAction[] = [
    {
      icon: { icon: 'sync-outline', pack: 'eva' },
      status: 'primary',
      tooltip: 'Profi.Neo Sync',
      action: () => this.openSyncDialog(),
    },
  ];

  constructor() {
    this.form = this.formBuilder.group({
      fullTextSearch: this.formBuilder.control(''),
      ownerTenantId: this.formBuilder.control<string | null>(null),
      buildingClass: this.formBuilder.control<string | null>(null),
      region: this.formBuilder.control<RegionItemDto | null>(null),
      regionId: this.formBuilder.control<string | null>(null),
      team: this.formBuilder.control<TeamItemDto | null>(null),
      teamId: this.formBuilder.control<string | null>(null),
      insuranceCompany: this.formBuilder.control<BuildingBaseData.InsuranceCompanyEnum | null>(null),
    });

    this.form.get('region')?.valueChanges.subscribe((region) => {
      if (region) {
        this.form.get('regionId')?.setValue(region.id);
      } else {
        this.form.get('regionId')?.setValue(null);
      }
    });

    this.form.get('team')?.valueChanges.subscribe((team) => {
      if (team) {
        this.form.get('teamId')?.setValue(team.id);
      } else {
        this.form.get('teamId')?.setValue(null);
      }
    });
  }

  navigateToBuilding(event: BuildingItemDto): void {
    this.router.navigate(['building', event.id]);
  }

  add(): void {
    this.router.navigate(['building', 'new']);
  }

  navigateToEquipment(event: Event, id: string): void {
    event.stopPropagation();
    this.router.navigate(['/buildingEquipments'], { queryParams: { buildingId: id } });
  }

  openSyncDialog(): void {
    this.dialogService.open(ProfiNeoSyncDialogComponent);
  }

}
